import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationPaymentSummaryDto extends EpimsBaseEntityDto {

   ObligationType: string;
   OwnerType: string;
    ObligationPeriod: string;
    TotalAcreage: number
    Unit: string;
    TotalAmount: number
    Description: string;
    FromDate: Date;
    ToDate: Date;
    LandCode: string;
    SubscriptionUserId: string;
    LandTitleId: string;
    ReminderDays: string;
    ReminderEmail: string;
    Years: string;
    Days: string;
    Rate: string;
    TerrainId: string;
    ApprovalStatus: string;
    Currency: string;
    LastCallDate: Date;
    NextCallDate: Date;
    FirstCallDate: Date;
    FacilityId: string;
    FacilityName: string;
    PaymentStatus: string;
    SubsciberId: string;
    COfONumber: string;
    Expiration: Date;
    CountryId: string;
    StateId: string;
    LgaId: string;
    Amount: number;
    PreviousAmount: number;
    RightsPaymentSummaryCode: string;
    ApprovalPersonId: string;
    ApprovalPersonName: string;
    ApprovalPersonRemarks: string;
    ApprovalPersonDate: Date;
    CreatedPersonId: string;
    CreatedDate: Date;
    StateName: string;
    LgaName: string;
    OwnerTypeName: string;
    PaymentDate: Date;
    PaymentRemarks: string;
    FirstCallYear: number;
    LastCallYear: number;
    RentExpirationStatus: string;
    RentExpirationId: string;
    CurrencyId: string;
    CurrencyName: string;
    ObligationPeriodName: string;
    Batch: string;
    BankId: string;
    BankName: string;
    AmountInWords: string;
    RateInWords: string;

}
